
export default function PaintFeatures() {
  const features = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Superior Coverage',
      description: 'High-hiding formula covers more area with fewer coats, saving time and money.',
    },
    {
      icon: 'ri-sun-line',
      title: 'UV Resistant',
      description: 'Advanced pigments resist fading and maintain color vibrancy for years.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Washable Finish',
      description: 'Durable surface withstands repeated cleaning without losing sheen.',
    },
    {
      icon: 'ri-temp-hot-line',
      title: 'Weather Resistant',
      description: 'Exterior formulas withstand harsh weather conditions and temperature extremes.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Low Odor',
      description: 'Low VOC formula with minimal smell for comfortable indoor application.',
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Fast Drying',
      description: 'Quick-dry technology allows for faster project completion and recoating.',
    },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-4 text-[#1A1A1A]">
          Key Features
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 md:mb-16 max-w-3xl mx-auto">
          Premium paint and coatings engineered for exceptional results and long-lasting beauty.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="text-center px-2">
              <div className="w-16 h-16 bg-[#F2C612] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-3xl text-[#1A1A1A]`}></i>
              </div>
              <h3 className="font-['Montserrat'] font-bold text-lg md:text-xl mb-3 text-[#1A1A1A]">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
